export const environment = {
  production: false,
  test: true,
  dev: false,
  baseUrl: 'https://test.api.sales.hansons.com/gbb/api/v2',
};
